export const companyInfo = {
  name: '祐灃室內裝修',
  slogan: '專業木作工藝・打造您的理想生活空間',
  description: '深耕台中逾20年，以精湛木工技藝為每一位客戶打造舒適、美觀且實用的室內空間。從設計到施工，全程專業把關，品質有保障。',
  phone: '04-2391-9988',
  mobile: '0975-210-616',
  address: '台中市太平區樹孝路274巷9弄21號1樓',
  email: 'service@yufeng-interior.com',
  lineId: '@yufeng_interior',
  established: 2008,
};

export const navLinks = [
  { label: '公司概況', href: '#about' },
  { label: '產品服務', href: '#services' },
  { label: '聯絡方式', href: '#contact' },
];

export const services = [
  {
    id: 1,
    icon: 'ri-home-roof-line',
    title: '天花板工程',
    description: '平頂、造型、輕鋼架天花板，各種材質精工施作，美觀耐用兼顧隔熱與吸音效果。',
    imageUrl: 'https://public.readdy.ai/ai/img_res/3ff884d7f0fb416679c6f9bbca52c15a.jpg',
  },
  {
    id: 2,
    icon: 'ri-layout-bottom-2-line',
    title: '地板工程',
    description: '木地板、超耐磨、卡扣地板等多種地坪選材，細緻鋪設施工，打造紮實舒適的地面基礎。',
    imageUrl: 'https://readdy.ai/api/search-image?query=professional%20hardwood%20floor%20installation%20interior%20design%20beautiful%20wood%20plank%20flooring%20modern%20living%20room%20warm%20tones%20natural%20light%20taiwan%20residential%20high%20quality%20photography&width=600&height=400&seq=service-floor-yufeng&orientation=landscape',
  },
  {
    id: 3,
    icon: 'ri-wall-line',
    title: '牆壁工程',
    description: '木作牆面、造型牆、文化石牆等多樣施作，為您的空間增添個性與層次感。',
    imageUrl: 'https://readdy.ai/api/search-image?query=beautiful%20accent%20wall%20interior%20design%20wooden%20wall%20panel%20modern%20bedroom%20warm%20neutral%20tones%20professional%20installation%20residential%20space%20clean%20minimalist%20taiwan&width=600&height=400&seq=service-wall-yufeng&orientation=landscape',
  },
  {
    id: 4,
    icon: 'ri-separator',
    title: '隔間工程',
    description: '木作隔間、輕隔間、玻璃隔間等靈活規劃，有效分隔空間，創造最佳使用動線。',
    imageUrl: 'https://readdy.ai/api/search-image?query=modern%20interior%20partition%20wall%20design%20wooden%20divider%20open%20plan%20living%20space%20taiwan%20residential%20contemporary%20style%20clean%20background%20professional%20craftsmanship%20warm%20lighting&width=600&height=400&seq=service-partition-yufeng&orientation=landscape',
  },
  {
    id: 5,
    icon: 'ri-archive-2-line',
    title: '櫥櫃工程',
    description: '量身訂製衣櫃、廚具、書櫃、電視牆等各式木作收納，空間利用最大化。',
    imageUrl: 'https://readdy.ai/api/search-image?query=custom%20built%20wooden%20cabinet%20wardrobe%20interior%20design%20taiwan%20residential%20modern%20style%20clean%20minimalist%20professional%20carpentry%20warm%20wood%20tones%20high%20quality%20photography&width=600&height=400&seq=service-cabinet-yufeng&orientation=landscape',
  },
];

export const stats = [
  { value: '20+', label: '年施工經驗' },
  { value: '500+', label: '完工案例' },
  { value: '98%', label: '客戶滿意度' },
  { value: '24h', label: '快速響應' },
];
